module.exports = __webpack_public_path__ + "static/img/jjc_third.db5d2ba4.png";